interface Props {
  label: string;
  value: string;
  sub?: string;
  accent?: "default" | "warn";
}

export default function CostSummaryCard({ label, value, sub, accent = "default" }: Props) {
  const valueClass =
    accent === "warn" ? "text-yellow-400" : "text-kw-text-primary";
  return (
    <div className="bg-kw-bg-elevated border border-kw-border-subtle rounded p-4">
      <div className="text-xs uppercase tracking-wide text-kw-text-muted">
        {label}
      </div>
      <div className={`text-2xl font-medium mt-1 ${valueClass}`}>{value}</div>
      {sub ? <div className="text-xs text-kw-text-faint mt-1">{sub}</div> : null}
    </div>
  );
}
